const cmaOps = require('./cmaOperations');

const pl = require('./data/cma_pl.json');
const plCacl = require('./calculations_PL');
const bsCacl = require('./calculations_BS');
const cfCalc = require('./calculations_CF');
const bsaCalc = require('./calculations_BSA');
const mpbfCalc = require('./calculations_MPBF');
const ffsCalc = require('./calculations_FFS');
const kfpCalc = require('./calculations_KFP');

export default (fys, cma_pl_values, cma_bs_values, cma_cf_values, cma_bsa_values, cma_mpbf_values, cma_ffs_values, cma_kfp_values) => {
  cma_pl_values = plCacl(cma_pl_values, fys, fys.length);
  cma_bs_values = bsCacl(cma_bs_values, cma_pl_values);
  cma_cf_values = cfCalc(fys.length, cma_cf_values, cma_bs_values, cma_pl_values);
  cma_bsa_values = bsaCalc(fys, fys.length, cma_bsa_values, cma_bs_values, cma_pl_values);
  cma_mpbf_values = mpbfCalc(fys.length, cma_mpbf_values, cma_bsa_values, cma_bs_values);
  cma_ffs_values = ffsCalc(fys.length, cma_ffs_values, cma_pl_values, cma_bs_values);
  cma_kfp_values = kfpCalc(fys, fys.length, cma_pl_values, cma_bs_values, cma_kfp_values);

  cma_bs_values.cma_bs_60 = cma_cf_values.cma_cf_38;
  cma_bs_values.cma_bs_59 = cmaOps.sum(cma_bs_values.cma_bs_60, cma_bs_values.cma_bs_61);
  cma_bs_values.cma_bs_89 = cmaOps.sum(cma_bs_values.cma_bs_59, cma_bs_values.cma_bs_62, cma_bs_values.cma_bs_65, cma_bs_values.cma_bs_69, cma_bs_values.cma_bs_70, cma_bs_values.cma_bs_79, cma_bs_values.cma_bs_80, cma_bs_values.cma_bs_81);
  cma_bs_values.cma_bs_117 = cmaOps.sum(cma_bs_values.cma_bs_89, cma_bs_values.cma_bs_95, cma_bs_values.cma_bs_112, cma_bs_values.cma_bs_116);
  cma_bs_values.cma_bs_119 = cmaOps.difference(cma_bs_values.cma_bs_89, cma_bs_values.cma_bs_28);
  cma_bs_values.cma_bs_120 = cmaOps.divide(cma_bs_values.cma_bs_89, cma_bs_values.cma_bs_28);

  return {
    pl_values: cma_pl_values,
    bs_values: cma_bs_values,
    cf_values: cma_cf_values,
    bsa_values: cma_bsa_values,
    mpbf_values: cma_mpbf_values,
    ffs_values: cma_ffs_values,
    kfp_values: cma_kfp_values,
  };
};



// WEBPACK FOOTER //
// ./src/cma/cma.js